import Spinners from "components/Common/Spinner"
import React from "react"

import { Row } from "reactstrap"
import BlockedStepsForWp from "./blockedStepsForWp"

const CaptureSelfie = ({ kycData, currentStep, querySteps = [] }) => {
  return (
    <>
      <div className="bank-details-wrapper">
        <h5 className="title mb-3">Capture Selfie</h5>
        <Row className="mb-2">
          <BlockedStepsForWp
            kycData={kycData}
            currentStep={currentStep}
            querySteps={querySteps}
          />
        </Row>
      </div>
    </>
  )
}

export default CaptureSelfie
